import { render } from "./AppRadio.vue?vue&type=template&id=1f0a3a08&scoped=true"
import script from "./AppRadio.vue?vue&type=script&lang=js"
export * from "./AppRadio.vue?vue&type=script&lang=js"

import "./AppRadio.vue?vue&type=style&index=0&id=1f0a3a08&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f0a3a08"]])

export default __exports__